export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9353.fa542b42.jpg";